namespace $.$$ {

	export class $shm_ba_agent_message_posts extends $.$shm_ba_agent_message_posts {

		rows() {
			const table = this.table() as $shm_ba_data_table | null
			if( !table?.rows.length ) return [ this.Empty() ]
			return table.rows.map( ( _, index )=> this.Post( index ) )
		}

		post_row( index: number ) {
			return ( this.table() as $shm_ba_data_table | null )?.rows[ index ] ?? null
		}

	}

}
